
import { Component,Watch, BaseMixins } from '../component';

class FromPageConfig{
    pageTitleL:string;      /*Card title多语言key*/
    labelWidth:number;      /*标签的宽度 默认150*/
    okText:string;          /*ok text key*/
    backText:string;        /*back text key*/
    successMsgText:string;  /*成功提示消息文本 */
    okAction:string;        /* ok dispatch type 需要操作数据库时 */
    isHideOk:boolean;       /*不显示OK 按钮*/
    isHideBack:boolean;     /*不显示Back 按钮*/
    isRedirectIndex:boolean;/*ok 后 返回Index页面*/
    getAction:string;       /* get dispatch type */
    model:any;
}

@Component
export class FormPageMixins extends BaseMixins {
    config:FromPageConfig = new FromPageConfig();

    model:any;

    get record(){ return {}};

    async mounted(){
        if(this.config.getAction){
            await (this.$refs["form-page"] as any).getRecord();
            this.model = this.$util.assign(this.record);
        }
    }
}